import _mixin from '../_mixin'

export default {
  name: 'SVersionRule',
  cnName: '规则按钮类',
  type: 'activity_version',
  preview: '',
  // 属性相关
  props: {
    ruleId: '6502a025c720be4224530c45',
    defaultBg: {
      src: '',
      style: {
        width: '156px',
        height: '40px'
      }
    },
    btnRule: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/12/e190705c9691852f032bc55176d5ffb9.png',
      style: {
        width: '156px',
        height: '40px',
        position: 'absolute',
        top: '0px',
        right: '',
        bottom: '',
        left: '0px'
      }
    },
    title: ''
  },
  propsDesc: [
    {
      target: 'ruleId',
      label: '规则Id'
    },
    {
      target: 'defaultBg',
      label: '底图',
      formType: 'image'
    },
    {
      target: 'btnRule',
      label: '规则按钮图片',
      formType: 'image'
    },
    {
      target: 'title',
      label: '标题'
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ]
}
